import WebStorageCache from 'web-storage-cache';

const webStorage = new WebStorageCache({
  // [可选] 'localStorage', 'sessionStorage', window.localStorage, window.sessionStorage
  //        或者其他实现了 [Storage API] 的storage实例.
  //        默认 'localStorage'.
  storage: 'localStorage',
  // [可选]  类型Number，公共超时事件设置。默认无限大
  exp: Infinity,
});

/**
 * 移除排除以外的storage
 * @param {数组} excluesKeys 需要排除的keys
 */
export const removeItemExcludes = (excluesKeys) => {
  if (!excluesKeys) {
    return;
  }
  const toRemoveItems = [];
  const storageItems = webStorage.storage;
  for (let i = 0, len = storageItems.length; i < len; i++) {
    // 获取key 索引从0开始
    const stroageKey = storageItems.key(i);
    if (stroageKey && !excluesKeys.includes(stroageKey)) {
      toRemoveItems.push(stroageKey);
    }
  }
  for (const removeItem of toRemoveItems) {
    webStorage.delete(removeItem);
  }
};

export default webStorage;
